import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from 'src/graphql/toneOfVoice';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendMutationUpdateWorkspaceAnalyzerTovDefaultArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateWorkspaceAnalyzerTovDefault(
    $generationTool: GenerationToolEnum!
    $customTovId: ID!
    $workspaceId: ID!
  ) {
    updateWorkspaceAnalyzerTovDefault(
      generationTool: $generationTool
      customTovId: $customTovId
      workspaceId: $workspaceId
    ) {
      ...CustomToneOfVoice
    }
  }
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

type Variables = BackendMutationUpdateWorkspaceAnalyzerTovDefaultArgs;
type Result = BackendCustomToneOfVoice;

export const updateWorkspaceAnalyzerTovDefault = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
